import React, { useContext, useEffect, useState } from "react";
import "./Checkout.css";
import { useNavigate } from "react-router-dom";
import Green_Btn from "../Common-Component/common_btn/green_btn/Green_Btn";
import Payment_Summary from "../MyAccount/Account/my_account_tabs/my_orders/order_details/payment_summary/Payment_Summary";
import { Form } from "react-bootstrap";
import OrderPlacedSuccessfullModal from "../Common_modal/OrderPlacedSuccessfullModal/OrderPlacedSuccessfullModal";
import axios from "axios"; // Make sure axios is installed/configured
import {
  checkOut,
  checkOutAfterPayment,
} from "../../utils/apis/orderProcess/orderProcess";
import { IDS } from "../../utils/common";
import { UserGet } from "../../utils/apis/myAccount/myAccount";
import Cookies from "js-cookie";
import { getCart } from "../../utils/apis/addToCart/addToCart";
import { Context } from "../../utils/context";

const Checkout = ({ note }) => {
  const navigate = useNavigate();
  const [order, setOrder] = useState(false);
  const { triggerCartUpdate } = useContext(Context);
  const [errorOrder, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("selectedAddress");
    if (saved) {
      setSelectedAddress(JSON.parse(saved));
    } else {
      navigate("/saved-address");
    }

    // Load Razorpay Script
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [navigate]);

  const productShareCookie = Cookies.get("product_share");

  const productShareData = productShareCookie
    ? JSON.parse(productShareCookie)
    : null;

  const formatAddress = (value) => {
    if (!value) return "";
    const parts = [];
    if (value.flat_home_bldg) parts.push(value.flat_home_bldg);

    if (value.address_type === "Apartment") {
      if (value.apt_number) parts.push(`Apt ${value.apt_number}`);
      if (value.floor) parts.push(`Floor ${value.floor}`);
      if (value.society_name) parts.push(value.society_name);
    } else if (value.address_type === "House") {
      if (value.floor) parts.push(`Floor ${value.floor}`);
      if (value.society_name) parts.push(value.society_name);
    } else if (value.address_type === "Office") {
      if (value.company) parts.push(value.company);
      if (value.floor) parts.push(`Floor ${value.floor}`);
    }

    if (value.col_land_strt) parts.push(value.col_land_strt);
    if (value.area_name) parts.push(value.area_name);
    if (value.additional_direction) parts.push(value.additional_direction);
    return parts.join(", ");
  };

  const [cartSummary, setcartSummary] = useState();
  // const openRazorpay = (orderData) => {
  //   const options = {
  //     key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_I05KCFb1v5JJRc",
  //     amount: Math.round(
  //       Number(cartSummary?.totals?.total_amount).toFixed(2) * 100,
  //     ),
  //     currency: "INR",
  //     name: "Local mandai",
  //     description: "Order Payment",
  //     image: "/assets/images/logo/logo.png",
  //     order_id: orderData.razorpay_order_id,
  //     handler: async (response) => {
  //       try {
  //         setLoading(true);

  //         const payload = {
  //           payment_mode: "online",
  //           address_id: selectedAddress.id,
  //           amount: Math.round(
  //             Number(cartSummary?.totals?.total_amount).toFixed(2) * 100,
  //           ),
  //           discount: 0,
  //           payment_id: response.razorpay_payment_id,
  //           tax_rupees: 0,
  //         };

  //         const result = await handlePlaceOrder();

  //         if (result) {
  //           setShowModal(true);
  //           localStorage.removeItem("cart");
  //         }
  //       } catch (error) {
  //         console.error("Payment success but order failed:", error);
  //         alert("Payment successful but order failed. Contact support.");
  //       } finally {
  //         setLoading(false);
  //       }
  //     },
  //     prefill: {
  //       name: "Customer Name",
  //       email: "customer@example.com",
  //       contact: "9999999999",
  //     },
  //     theme: {
  //       color: "#052c65",
  //     },
  //     modal: {
  //       ondismiss: () => {
  //         setLoading(false);
  //         alert("Payment cancelled");
  //       },
  //     },
  //   };

  //   const rzp = new window.Razorpay(options);
  //   rzp.open();
  // };

  const openRazorpay = async (price, data) => {
    const amountInPaise = Math.round(Number(price) * 100);

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Local Mandai",
      description: "Order Payment",
      order_id: data?.razorpay_order_id,

      handler: async function (res) {
        try {
          await PaymentOnlineCreate({
            order_id: data.id,
            payment_id: res.razorpay_payment_id,
            // razorpay_order_id: res.razorpay_order_id,
            // razorpay_signature: res.razorpay_signature,
          });
        } catch (err) {
          console.log(err);
        }
      },
      modal: {
        ondismiss: function () {
          setLoading(true);
        },
      },

      prefill: {
        name: user?.first_name,
        email: user?.email,
        contact: user?.contact_no,
      },

      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new window.Razorpay(options);
    rzpay.open();
  };

  const [user, setUser] = useState(false);
  const getUser = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUser(res.data);
    }
  };
  useEffect(() => {
    getUser();
  }, []);

  const PaymentOnlineCreate = async (data) => {
    const res = await checkOutAfterPayment(data?.order_id, data);

    if (res?.success) {
      await triggerCartUpdate();
      setShowModal(true);
      setLoading(false);
      localStorage.removeItem("cart");
      localStorage.removeItem("product_share");
    }
  };

  const handlePlaceOrder = async () => {
    if (!selectedPaymentMethod) {
      alert("Please select a payment method");
      return;
    }
    try {
      setLoading(true);
      const payload = {
        payment_mode: selectedPaymentMethod,
        address_id: selectedAddress.id,
        note: note,
        cartSummary,
      };

      const result = await checkOut(payload);

      if (result?.success) {
        if (selectedPaymentMethod === IDS.Payment_Mode.Online) {
          const amount = parseFloat(cartSummary?.totals?.total_amount);
          const orderData = result?.data;

          await openRazorpay(amount, orderData);
        } else {
          setOrder(result?.data);
          setShowModal(true);
          setLoading(false);
          localStorage.removeItem("cart");
          localStorage.removeItem("product_share");
        }

        await triggerCartUpdate();
      } else {
        setError(result?.message);
      }
    } catch (err) {
      console.error(err);
      alert("Order failed");
    } finally {
      // setLoading(false);
    }

    return;
  };

  return (
    <section className="Cart Checkout">
      <div className="container">
        <div className="cart_main_container">
          <div className="data_holder">
            <div className="row">
              <div className="col-lg-8 col-md-12">
                <div className="left_side_card">
                  <section className="Select_payment_sec">
                    {/* Address */}
                    <div className="paybox">
                      <div className="addflex">
                        <div className="icondiv">
                          <img
                            className="loc-img"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/checkout/location.png"
                            }
                            alt="location"
                          />
                        </div>
                        <div className="contdiv">
                          <p className="apartp">
                            <img
                              className="aprticn"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/Image/Icon/Apartment.png"
                              }
                              alt="icon"
                            />
                            {selectedAddress?.address_type}
                          </p>
                          <p className="address">
                            {formatAddress(selectedAddress)}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* UPI Options - Triggers Razorpay */}
                    {/* <div className="paybox">
                      <h6 className="boxtitle">Recommended for You</h6>
                      <p className="payp">Pay with UPI</p>
                      <div className="row">
                        {["gpay1.png", "phonepe.png", "paytm.png"].map(
                          (img, i) => (
                            <div className="col-md-3 col-4" key={i}>
                              <Form.Check
                                type="radio"
                                name="paymentMethod"
                                id={`upi-${i}`}
                                label={
                                  <img
                                    className="payimg"
                                    src={
                                      process.env.PUBLIC_URL +
                                      `/assets/Image/Icon/${img}`
                                    }
                                    alt="upi"
                                  />
                                }
                                onChange={() => setSelectedPaymentMethod(IDS)}
                              />
                            </div>
                          )
                        )}
                      </div>
                    </div> */}
                    <div className="paybox">
                      <div className="addflex justify-content-between">
                        <div className="contdiv">
                          <h6 className="boxtitle">Online</h6>
                          <p className="address">
                            <img
                              className="delimg"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/Image/Icon/pay1.png"
                              }
                            />
                            Online
                          </p>
                        </div>
                        <div className="icondiv">
                          <Form.Check
                            type="radio"
                            name="paymentMethod"
                            onChange={() =>
                              setSelectedPaymentMethod(IDS?.Payment_Mode.Online)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    {/* Cash on Delivery */}
                    <div className="paybox">
                      <div className="addflex justify-content-between">
                        <div className="contdiv">
                          <h6 className="boxtitle">Pay on Delivery</h6>
                          <p className="address">
                            <img
                              className="delimg"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/Image/Icon/pay1.png"
                              }
                            />
                            Pay on Delivery (Cash)
                          </p>
                        </div>
                        <div className="icondiv">
                          <Form.Check
                            type="radio"
                            name="paymentMethod"
                            onChange={() =>
                              setSelectedPaymentMethod(IDS.Payment_Mode.COD)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    {/* Wallet - Optional */}
                    {Number(user?.users_wallet?.amount) >=
                      Number(cartSummary?.totals?.total_amount) && (
                      <div className="paybox">
                        <div className="addflex justify-content-between">
                          <div className="contdiv">
                            <h6 className="boxtitle">Wallet</h6>
                            {/* <p className="address">
                            <img
                              className="delimg"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/Image/Icon/wallet.png"
                              }
                            />
                            Balance : ₹ 0
                          </p> */}
                          </div>
                          <div className="icondiv">
                            <Form.Check
                              type="radio"
                              name="paymentMethod"
                              onChange={() =>
                                setSelectedPaymentMethod(
                                  IDS.Payment_Mode.Wallet,
                                )
                              }
                            />
                          </div>
                          {/* <div className="icondiv">
                          <button
                            className="addwalbtn"
                            onClick={() => navigate("/add-wallet")}
                          >
                            Add
                          </button>
                        </div> */}
                        </div>
                      </div>
                    )}
                  </section>
                </div>
              </div>

              {/* Payment Summary */}
              <div className="col-lg-4">
                <Payment_Summary
                  errorOrder={errorOrder}
                  product_id={productShareData?.product_id}
                  user_id={productShareData?.user_id}
                  setcartSummary={setcartSummary}
                  cartSummary={cartSummary}
                  isCheckoutPage
                  checkout_btn={loading ? "Processing..." : "Place Order"}
                  checkoutAction={
                    selectedPaymentMethod === IDS.Payment_Mode.Online
                      ? handlePlaceOrder
                      : handlePlaceOrder
                  }
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal */}
      <OrderPlacedSuccessfullModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
          navigate("/order-details");
        }}
        baseLink={`/my-orders`}
      />
    </section>
  );
};

export default Checkout;
